import { pageDto } from "../pagedto";
import { PaginationFeaturesDto } from "../paginationfeaturesdto";
import { RateModelDto } from "../ratemodeldto";
import { DiscountControlTypeDto } from "./DiscountControlTypesDto.model";
import { GeneralDiscountCatalogDto } from "./GeneralDiscountCatalogDto.model";

export class DiscountModelRateControlTypeDto {
    discountModelRateControlTypePkDto?: {
        rateModelId?: number,
        generalDiscountCatalogId: number | undefined
        discountControlTypeId: number | undefined
    };
    discountControlTypeDto?: DiscountControlTypeDto
    generalDiscountCatalogDto?: GeneralDiscountCatalogDto;
    rateModelDto?: RateModelDto;
    discountValidationRateModelWithControlTypeDto?: DiscountValidationRateModelWithControlTypeDto

    constructor(data?: Partial<DiscountModelRateControlTypeDto>) {
        Object.assign(this, data);
    }
}

export class DiscountModelRateControlTypeResponse {
    discountModelRateControlTypeDto: DiscountValidationRateModelWithControlTypeDto[] = [];
    pageDto: pageDto = new pageDto({});
}

export class DiscountModelRateControlTypeRequest {
    discountModelRateControlTypeDto: DiscountValidationRateModelWithControlTypeDto = new DiscountValidationRateModelWithControlTypeDto();
    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});

}

export class DiscountValidationRateModelWithControlTypeDto {
    idDiscountValidationRateModelWithControl?: number;
    alphanumericValue?: string;
    numericValue?: number | undefined;
    decimalValue?: number;
    valueStartDate?: string | undefined;
    valueEndDate?: string | undefined;
    description?: string;
}